import WebRoutes from "../pages/WebRoutes";
import { AI, BI, BS, FA, GI, HI, IO5, MD } from "./Icons";

import { ReactComponent as WalletSvG } from "../assets/svg/wallet.svg";
import { ReactComponent as Group } from "../assets/svg/Group.svg";
import { ReactComponent as Money } from "../assets/svg/Money.svg";
import { ReactComponent as France } from "../assets/svg/France.svg";
import { ReactComponent as Support } from "../assets/svg/Support.svg";
import { ReactComponent as Exclusive } from "../assets/svg/Exclusive.svg";

export const BenefitsCard = [
  {
    icon: <GI.GiAirplaneDeparture />,
    detail: "Free Branded Travel Website",
  },
  {
    icon: <AI.AiOutlineRise />,
    detail: "Increase Engagement",
  },
  {
    icon: <MD.MdOutlineDataSaverOn />,
    detail: "Exclusive Membership Savings",
  },
  {
    icon: <MD.MdOutlineLoyalty />,
    detail: "Loyalty Program",
  },
  {
    icon: <AI.AiFillLock />,
    detail: "Password Protected/Members Only Access",
  },
  {
    icon: <HI.HiUsers />,
    detail: "Increase Membership Size/Employee Retention",
  },
  {
    icon: <GI.GiReceiveMoney />,
    detail: "Revenue Share",
  },
  {
    icon: <GI.GiTrophy />,
    detail: "Trip Contests",
  },
];

export const ProcessCard = [
  {
    src: require("../assets/images/howitworks-1.jpg"),
    heading: "SIGN UP",
    subheading: "YOUR JOURNEY STARTS HERE",
    detail:
      "We will get in touch with you within 24 hours, to explain the next steps and answer any other questions.",
  },
  {
    src: require("../assets/images/howitworks-2.png"),
    heading: "EMAIL US YOUR LOGO",
    subheading: "THIS IS WHERE WE RECEIVE YOUR LOGO",
    detail: "We will start creating your own branded travel website.",
  },
  {
    src: require("../assets/images/howitworks-3.jpg"),
    heading: "GO LIVE!",
    subheading: "WOO HOO! YOUR TRAVEL WEBSITE IS NOW LIVE!",
    detail:
      "You now have your password protected website. The site is easy to navigate and we will manage it for you entirely. We will explore and implement new features as we continue to grow our partnership together.",
  },
];

export const WebTemplate = [
  {
    src: require("../assets/images/howitworks-1.jpg"),
  },
  {
    src: require("../assets/images/howitworks-2.png"),
  },
  {
    src: require("../assets/images/howitworks-3.jpg"),
  },
  {
    src: require("../assets/images/howitworks-1.jpg"),
  },
];

export const Benefits = [
  {
    icon: <GI.GiAirplaneDeparture />,
    detail: "Free Branded Travel Websites",
  },
  {
    icon: <MD.MdOutlineGroups />,
    detail: "Member only access",
  },
  {
    icon: <MD.MdOutlineDataSaverOn />,
    detail: "Exclusive membership saving",
  },
  {
    icon: <MD.MdPersonAddAlt1 />,
    detail: "increase membership size",
  },
  {
    icon: <IO5.IoPeopleCircleOutline />,
    detail: "Increase Employee/Membership Retention",
  },
  {
    icon: <MD.MdOutlineLoyalty />,
    detail: "loyalty program",
  },
  {
    icon: <GI.GiProfit />,
    detail: "Enhance your benefits program",
  },
  {
    icon: <AI.AiOutlineRise />,
    detail: "Increase engagement",
  },
];

export const MembershipBenefitsCard = [
  {
    icon: <GI.GiAirplaneDeparture />,
    detail: "Free Branded Travel Website",
  },
  {
    icon: <AI.AiOutlineRise />,
    detail: "Increase Engagement",
  },
  {
    icon: <MD.MdOutlineDataSaverOn />,
    detail: "Exclusive Membership Savings",
  },
  {
    icon: <MD.MdOutlineLoyalty />,
    detail: "loyalty program",
  },
  {
    icon: <AI.AiFillLock />,
    detail: "Password Protected/Members Only Access",
  },
  {
    icon: <MD.MdPersonAddAlt1 />,
    detail: "Increase Membership Size",
  },

  {
    icon: <GI.GiReceiveMoney />,
    detail: "Revenue Share",
  },
  {
    icon: <GI.GiTrophy />,
    detail: "Trip Contests",
  },
];

export const employeeBenefitCard = [
  {
    icon: <GI.GiAirplaneDeparture />,
    detail: "Free Branded Travel Website",
  },
  {
    icon: <AI.AiOutlineRise />,
    detail: "Increase Engagement",
  },
  {
    icon: <MD.MdOutlineDataSaverOn />,
    detail: "Exclusive Membership Savings",
  },
  {
    icon: <MD.MdOutlineLoyalty />,
    detail: "loyalty program",
  },
  {
    icon: <AI.AiFillLock />,
    detail: "Password Protected/Members Only Access",
  },
  {
    icon: <MD.MdPersonAddAlt1 />,
    detail: "Increase Membership Size",
  },
  {
    icon: <GI.GiReceiveMoney />,
    detail: "Revenue Share",
  },
  {
    icon: <GI.GiTrophy />,
    detail: "Trip Contests",
  },
];

export const EmployerBenefitsCard = [
  {
    icon: <GI.GiAirplaneDeparture />,
    detail: "Free Branded Travel Website",
  },
  {
    icon: <AI.AiOutlineRise />,
    detail: "Increase Engagement",
  },
  {
    icon: <MD.MdOutlineDataSaverOn />,
    detail: "Exclusive Membership Savings",
  },
  {
    icon: <MD.MdOutlineLoyalty />,
    detail: "loyalty program",
  },
  {
    icon: <AI.AiFillLock />,
    detail: "Password Protected/Members Only Access",
  },
  {
    icon: <MD.MdPersonAddAlt1 />,
    detail: "Increase Membership Size",
  },

  {
    icon: <GI.GiReceiveMoney />,
    detail: "Revenue Share",
  },
  {
    icon: <GI.GiTrophy />,
    detail: "Trip Contests",
  },
];
export const TravelSupplierssBenefitsCard = [
  {
    icon: <AI.AiOutlineRise />,
    detail: "Increase Brand Awareness",
  },
  {
    icon: <FA.FaUsers />,
    detail: "Reach New Customers",
  },
  {
    icon: <GI.GiMedal />,
    detail: "Showcase Group Departures",
  },
  {
    icon: <FA.FaBoxOpen />,
    detail: "Move Distressed Inventory",
  },
  {
    icon: <BI.BiPodcast />,
    detail: "Webinar Presentation Opportunities",
  },
  {
    icon: <BS.BsNewspaper />,
    detail: "Newsletters to Communicate Special Savings",
  },
  {
    icon: <GI.GiReceiveMoney />,
    detail: "Increase Sales",
  },
  {
    icon: <GI.GiTrophy />,
    detail: "API Integration - Display All Trips",
  },
];
export const BlogContent = [
  {
    src: require("../assets/images/hq.jpg"),
    name: "TOM MACLEAN",
    position: "Co-Founder / Director of Sales & Marketing",
    Bio: [
      "Tom was born and raised on Vancouver Island. He started traveling at only a few months old and has had a passion for it ever since. He’s now traveled to every continent, except for one, Antarctica.",
      "Tom went to college and received a diploma in Marketing and Sales. After completing that course he decided to go to Cancun in 1998, and applied for various positions. Eventually securing a position in sales for a vacation club at one of the top resorts. Turns out, he had a knack for sales and that was the turning point in his career. Sales and Travel were to become his two passions.",
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
      "Tom was born and raised on Vancouver Island. He started traveling at only a few months old and has had a passion for it ever since. He’s now traveled to every continent, except for one, Antarctica.",
    ],
  },
  {
    src: require("../assets/images/ryan.jpg"),
    name: "RYAN MIKUCKI",
    position: "Co-Founder/ Director of Business Development",
    Bio: [
      "Ryan’s passion for travel and exploration has taken him to over 80 countries across all 7 continents, fueled by a lifelong curiosity for discovering new cultures and global adventures. Born and raised in Winnipeg, Manitoba, he earned a degree in Recreation Management and Community Development from the University of Manitoba, with a minor in Marketing. Early on, he completed an internship at The Westin Resort in Los Cabos, Mexico—an experience that confirmed his desire to pursue a career in the travel industry.",
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
      "Ryan’s passion for travel and exploration has taken him to over 80 countries across all 7 continents, fueled by a lifelong curiosity for discovering new cultures and global adventures. Born and raised in Winnipeg, Manitoba, he earned a degree in Recreation Management and Community Development from the University of Manitoba, with a minor in Marketing. Early on, he completed an internship at The Westin Resort in Los Cabos, Mexico—an experience that confirmed his desire to pursue a career in the travel industry.",
      "His professional journey began with Collette Vacations, where he spent a decade advancing from Business Development Manager to Director of Sales for Canada. In 2017, he transitioned into travel technology as VP of Business Development, helping travel professionals adapt to digital solutions. A year later, he was named a “Top 40 Under 40” by Canadian Traveller Magazine—the same year he co-founded Trip Merchant, a company born from his deep industry insight and entrepreneurial spirit.",
    ],
  },
  {
    src: require("../assets/images/IMG_3910.jpeg"),
    name: "ANELISA ANDERSON",
    position: "Retail & Group Reservation Agent",
    Bio: [
      "Anelisa was born in Edmonton and at just a day old she was adopted and hopped on a plane to Richmond, BC where she grew up. After graduating high school, she started her passion for travel by exploring South East Asia and Australia. On her return to Canada, she attended Vancouver Community College graduating with a diploma for Hospitality Management. Anelisa was then on a one way ticket to Bangkok to explore South East Asia again but this time as a solo traveler. Next stop was Europe, where she enjoyed country hopping every couple days to see and explore as much as she could.",
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
      "Eventually coming home and settling down, she secured a position in the travel industry at a river and ocean cruise company (Scenic & Emerald) in 2017. Working in the reservations department as a sales agent and then supervisor. During her time in reservations, she earned monthly top sales awards and the employee of the year award for Canada in 2019. She would eventually move to the groups department post pandemic where she gained even further knowledge in a new department.",
      "Anelisa had her baby boy in October of 2022, only to start with Trip Merchant exactly one year later on the day of her son’s birthday. Juggling being a mom, wife and not giving up on her true passion for travel and a career has been interesting but rewarding!",
    ],
  },
  // {
  //   src: require("../assets/images/travel1.jpg"),
  //   name: "LYNETTE KELLY",
  //   position: "Retail & Group Reservation Agent",
  //   Bio: [
  //     "Lynette took Tourism and Travel in college, then applied for the role of travel agent.  She worked her way through to team leader, and lead an award winning team for many years.  Lynette’s passion for helping every client, regardless of destination, earned her the title of one of the top travel agents in her city for many years.  Her love of Luxury Caribbean travel earned Lynette a top sales award for Sandals resorts.  After a short break from the travel industry after having children, Lynette joined Trip Merchant in October 2023.",
  //   ],
  //   linkedIn: "https://www.linkedin.com/company/trip-merchant/",
  //   Readmore: [
  //     "Lynette took Tourism and Travel in college, then applied for the role of travel agent.  She worked her way through to team leader, and lead an award winning team for many years.  Lynette’s passion for helping every client, regardless of destination, earned her the title of one of the top travel agents in her city for many years.  Her love of Luxury Caribbean travel earned Lynette a top sales award for Sandals resorts.  After a short break from the travel industry after having children, Lynette joined Trip Merchant in October 2023.",
  //   ],
  // },
  {
    src: require("../assets/images/Judy.jpg"),
    name: "Judy Phillips",
    position: "Group Reservation Agent",
    Bio: [
      "Judy found her way into the travel industry over 30 years ago. After graduating from the Travel and Tourism program at SAIT in Calgary, she started her career in Regina as a travel consultant with a large travel company. Within a few years she was asked to manage the group travel department and did so successfully for 22 years. Throughout those years, she honed her skills as an accomplished travel planner developing a wide array of specialty groups.",
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
      "Her greatest joy is hosting like-minded guests on globe-trotting adventures by land and sea. As she says, fortune has been kind to allow her to travel all over this amazing world, and now the bucket list has checkmarks from some of the utmost Wonders of the World. For her, viewing ancient engineering marvels such as the great pyramids of Egypt, the Great Wall of China, Petra in Jordan, Taj Mahal in India, Machu Picchu in Peru and Angkor Wat in Cambodia is not only awe inspiring but allows someone to immerse themselves in the environments of each country. The joy of travel is the window into learning and understanding these new and remarkable cultures. \n Judy is proud to be a part of the Trip Merchant team since 2019. She has hosted Trip Merchant Journeys group departures to Spain and Morocco in February 2020, Egypt in October 2022, and India in October 2024. She is honoured to be trusted by company co-founders Ryan and Tom to accompany their Trip Merchant guests on unforgettable trips where many incredible memories are created. \n" +
      "\n" +
      "“One's destination is never a place, but a new way of seeing things.'' -- Henry Miller",
    ],
  },
    {
    src: require("../assets/images/melinda.png"),
    name: "Melinda Anderson",
    position: "Retail & Group Reservation Agent",
    Bio: [
        "Melinda had already lived on three different continents by the age of three, so it's no surprise\n" +
        "that a love of travel came naturally. With family spread across the globe, discovering new\n" +
        "destinations and cultures has always felt like second nature.",
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
        "Melinda had already lived on three different continents by the age of three, so it's no surprise\n" +
        "that a love of travel came naturally. With family spread across the globe, discovering new\n" +
        "destinations and cultures has always felt like second nature.",
      "A six-week overseas trip at the age of eleven sparked a lifelong passion for travel and proved\n" +
      "just how powerful and memorable travel experience can be, and in 2012, she turned that\n" +
      "passion into a career. Over the years, Melinda gained extensive experience across both retail\n" +
      "and group travel, working with a wide range of clients, itineraries and destinations.",
      "Having visited 30 countries so far- with many more still on her ever-growing bucket list- Melinda\n" +
      "brings both personal experience and professional expertise to every trip she plans. She is\n" +
      "excited to be part of the Trip Merchant team and looks forward to helping clients create\n" +
      "seamless, memorable, and stress-free travel experiences they'll treasure for years to come."    ],
  },
    {
    src: require("../assets/images/Maggie-Robb.jpg"),
    imgStyle: { aspectRatio: "4/3", objectFit: "cover", objectPosition: "center top" },
    name: "Maggie Robb",
    position: "Retail & Group Reservation Agent",
    Bio: [
        "Born and raised in Winnipeg, Manitoba and now living in beautiful Winnipeg Beach, Manitoba.\n" +
        "Maggie grew up inspired by her mom’s work in the travel industry, which eventually led her to begin her own travel career in 2014.\n" +
        "Since then, she has worked across leisure, corporate, group travel, emergency travel support, and customer experience roles."
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
      "Born and raised in Winnipeg, Manitoba and now living in beautiful Winnipeg Beach, Manitoba.\n" +
        "Maggie grew up inspired by her mom’s work in the travel industry, which eventually led her to begin her own travel career in 2014.\n" +
        "Since then, she has worked across leisure, corporate, group travel, emergency travel support, and customer experience roles." ,
        "With an educational background in accounting as well as digital and social media marketing, Maggie brings both creativity and organization into the way she plans travel.\n" +
        "She’s a natural planner and problem solver who loves bringing all the details together to help create smooth, memorable, and stress-free experiences for travellers." ,
        "Having visited 15 countries so far, Maggie is always dreaming about the next destination and loves helping others do the same.\n" +
      "Outside of work, she enjoys life by the lake with her two dogs and cat, especially walks on the beach with them." ,
     "Maggie is excited for this next chapter with Trip Merchant and looks forward to helping clients experience the joy and connection that travel can bring."    ],
  },
    {
    src: require("../assets/images/Jechelle-Custodio.jpg"),
    imgStyle: { aspectRatio: "4/3", objectFit: "cover", objectPosition: "center 30%" },
    name: "Jechelle Custodio",
    position: "Group Reservation Agent",
    Bio: [
        "Originally from the Philippines, Jechelle moved to Canada and eventually found her way into the travel industry after graduating from SAIT with a diploma in Travel and Tourism.\n" +
        "With a long-standing background in customer service, she discovered a passion for creating seamless travel experiences and helping people explore the world."
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
      "Originally from the Philippines, Jechelle moved to Canada and eventually found her way into the travel industry after graduating from SAIT with a diploma in Travel and Tourism.\n" +
        "With a long-standing background in customer service, she discovered a passion for creating seamless travel experiences and helping people explore the world.",
      "Over the past three years, she has worked primarily in corporate and incentive travel, helping coordinate group travel and flights to destinations around the world.\n" +
        "She enjoys the challenge of putting all the moving pieces together and making sure everything runs as smoothly as possible, even when travel plans don’t go exactly as expected.",
      "Outside of work, Jechelle loves exploring new places, taking road trips, and traveling with her two dogs whenever she can.\n" +
        "She believes the best part of travel is not just where you go, but the memories you create along the way."    ],
  },
    {
    src: require("../assets/images/Jillian-Bessette.jpg"),
    imgStyle: { aspectRatio: "4/3", objectFit: "cover", objectPosition: "center 20%" },
    name: "Jillian Bessette",
    position: "Retail & Group Reservation Agent",
    Bio: [
        "Jillian lives, eats, breathes and sleeps travel — literally. She thinks about it when she wakes up on a rainy day and is reminded of Scotland, when she enjoys shrimp reminiscent of seafood she had on a beach, or when a sunburn stings like the doozy she got in Australia.\n" +
        "She also loves talking with people about their own travel dreams, and working in the travel industry has allowed her to do that every day since 2011."
    ],
    linkedIn: "https://www.linkedin.com/company/trip-merchant/",
    Readmore: [
      "Jillian lives, eats, breathes and sleeps travel — literally. She thinks about it when she wakes up on a rainy day and is reminded of Scotland, when she enjoys shrimp reminiscent of seafood she had on a beach, or when a sunburn stings like the doozy she got in Australia.\n" +
        "She also loves talking with people about their own travel dreams, and working in the travel industry has allowed her to do that every day since 2011.",
      "She has experienced most types of travel, including touring, ocean and river cruising, rail travel, and road trips throughout parts of Canada and the US.\n" +
        "She has explored the resorts of Mexico, various Caribbean islands, and highlights of Australia, while also travelling extensively throughout Europe — her area of expertise and favourite destination — experiencing both its rich history and modern culture.",
      "It’s a big world, and the bucket list only grows. She’s passionate about helping travellers find, build, book and experience whatever makes their travel heart sing!"    ],
  },
  // {
  //   src: require("../assets/images/Taylor1.png"),
  //   name: "TAYLOR ",
  //   position: "Retail & Group Reservation Agent",
  //   Bio: [
  //     "Taylor has had a passion for travel and adventure from a young age.  Growing up in North Vancouver she was quite competitive with sports which lead her to travel around the US and Canada quite frequently.  She graduated from Indiana University with a Bachelor’s degree and moved around before finding herself back in North Vancouver where she worked in corporate travel for Aritzia.  She recently embarked on solo trip to Southeast Asia and fell in love with the food, culture, landscapes and amazing people.  She is excited to be a part the Trip Merchant team and to continue to explore all the beautiful countries this world has to offer!",
  //   ],
  //   linkedIn: "https://www.linkedin.com/company/trip-merchant/",
  //   Readmore: [
  //     "Taylor has had a passion for travel and adventure from a young age.  Growing up in North Vancouver she was quite competitive with sports which lead her to travel around the US and Canada quite frequently.  She graduated from Indiana University with a Bachelor’s degree and moved around before finding herself back in North Vancouver where she worked in corporate travel for Aritzia.  She recently embarked on solo trip to Southeast Asia and fell in love with the food, culture, landscapes and amazing people.  She is excited to be a part the Trip Merchant team and to continue to explore all the beautiful countries this world has to offer!",
  //   ],
  // },
];

export const NavLinksMain = [
  {
    title: "Why Trip Merchant",
    link: WebRoutes.generalSubscription,
  },
  {
    title: "Trip Merchant Journeys",
    link: WebRoutes.tripmerchantJourneys,
  },
  {
    title: "Rewards",
    link: WebRoutes.rewards,
  },
  {
    title: "Newsletter Sign Up",
    link: "#newsLetterSignUp",
    anchor: true
  },
];

export const NavLinks = [
  {
    title: "HOME",
    anchor: false,
    link: "/home",
  },
  {
    title: "BENEFITS",
    link: WebRoutes.benefits,
    children: [
      {
        title: "HOW IT WORKS",
        link: WebRoutes.howItWorks,
      },
    ],
  },

  {
    title: "WHO WE ARE",
    link: WebRoutes.WhoWeAre,
  },
  {
    title: "PARTNER WITH US",
    link: WebRoutes.partnerWithUs,
    children: [
      {
        title: "Membership-Based Organization",
        link: WebRoutes.membershipBasedOrganizations,
      },
      {
        title: "Employers",
        link: WebRoutes.employers,
      },
    ],
  },

  {
    title: "Travel Suppliers",
    link: WebRoutes.travelSuppliers,
  },
];

export const cardData = [
  {
    heading: "Earn Loyalty Credits",
    describe: "Be rewarded for traveling with Trip Merchant!",
    svg: <WalletSvG className="walletSvg" />,
  },
  {
    heading: "Member Exclusive Trips",
    describe: "Get best price and fare with Trip Merchant!",
    svg: <Group className="groupSvg" />,
  },
  {
    heading: "No Booking Fees",
    describe: "Make trip free of service charge with Trip Merchant!",
    svg: <Money className="money" />,
  },
  {
    heading: "Exclusive Benefits & Savings",
    describe: "Get Best deals at Trip Merchant",
    svg: <Exclusive className="exclusive" />,
  },
  {
    heading: "Trip Contests",
    describe: "Get Exclusive Benefits if Your are Canadian",
    svg: <France className="france" />,
  },
  {
    heading: "Expert Travel Support",
    describe: "Get full travel guidance with trip merchant experts",
    svg: <Support className="support" />,
  },
];

export const infoSectionCards = [
  {
    heading: "Flexible Deposit",
    svg: <WalletSvG className="walletSvg" />,
  },
  {
    heading: "Group Pricing",
    svg: <Group className="groupSvg" />,
  },
  {
    heading: "Final Payment Policies",
    svg: <Money className="money" />,
  },
  {
    heading: "Exclusive Perks",
    svg: <Exclusive className="exclusive" />,
  },
  /*  {
    heading: "Travel with Like-Minded Individuals",
    svg: <France className="france" />,
  }, */
  {
    heading: "Travel with Like-Minded Individuals",
    svg: <Support className="support" />,
  },
  {
    heading: "Travel with Like-Minded Individuals",
    svg: <Support className="support" />,
  },
];

export const imageBanner = [
  {
    src: require("../assets/images/01.jpg"),
  },
  {
    src: require("../assets/images/02.jpg"),
  },
  {
    src: require("../assets/images/03.jpg"),
  },
  {
    src: require("../assets/images/04.jpg"),
  },
  {
    src: require("../assets/images/05.jpg"),
  },
  {
    src: require("../assets/images/06.jpg"),
  },
];
